module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAABSUlEQVRIiZ3VS27CMBCA4R876iHKrvfoHk5QqtCUozVVkMoqS04Et7DUhT1grPgxjIQiHMdfnMxMVvM8E0UPbIAD4NCHBUbgDBxlsIsm7IGfMNECX0rIAhOwCz8EMgsAwGe4wNIWMSD/R/yToVsAJOSCPeUdpUA8PgIrA2wLd7yjvKMcEJ/fGmAAToU7zUE1gLDuYPCPoldCrUAPOHnxGuhFA8BjCgsE8FGA3oF1KwD3FE6h0o5UwBLSCjUDOeQZKAuUEIEG4FoBLmFetmBLiAV+gdcKssZXdrYF5RCLb265LEuj2BmWEC1QhVKkBbhooRhpAU7AG/XOcIwhqfhWQNK01hlkvAdc9wSAFurwaaoBJFohZ/Af/VwhFSuZemdwwNngs+GwsFANqEEurDtJdqXQXyOQg24APH5PpnDcAN8KIIUc/hXIevwDibt0ku7o7r0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon22.png
// module id = nzRw
// module chunks = 1